import React, { useState, useEffect } from 'react';
import FormFieldItem, { CreateInventoryFormPanel } from './FormLayout';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import { asset_status_options, yes_no_options } from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';

const ControlsControl = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    aquireLocationsOptions,
    aquireLocation,
    setAquireLocation,
    locations,
    location,
    setLocation,
    name,
    setName,
    assetStatus,
    assetStatusTypes,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    ErrorObject,
    id,
    maxDate,
    subLocation,
    setSubLocation,
}) => {
    const [isCalifornia, setIsCalifornia] = useState(false);
    useEffect(() => {
        try {
            var isCali = locations.filter((obj) => obj.value == location)[0].state === "CA"
            setIsCalifornia(isCali)
        } catch { }
    }, [location])

    return (
        <CreateInventoryFormPanel enabled={!id}>
            {
                id == 0 && (

                    <FormFieldItem>
                        <Select
                            value={newPurchaseAquisition}
                            label="Is this a new purchase / acquisition?"
                            options={yes_no_options}
                            onChange={e => setNewPurchaseAquisition(e.target.value)}
                            error={ErrorObject.NewPurchaseAquisition}
                        />
                    </FormFieldItem>

                )
            }
            {
                newPurchaseAquisition == 1 && (
                    <FormFieldItem>
                        <Select
                            required
                            value={aquireLocation}
                            label="Acquired From Location"
                            options={aquireLocationsOptions}
                            onChange={e => setAquireLocation(e.target.value)}
                            error={ErrorObject.AquireLocation}
                        />
                    </FormFieldItem>
                )
            }
            <LocationDropdown
                required
                disabled={id}
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={setLocation}
                onChangeSubLocation={setSubLocation}
                ErrorObject={ErrorObject.location}
            />
            <FormFieldItem>
                <Input
                    required
                    fullWidth
                    label="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    error={ErrorObject.Name}
                    helperText={typeof ErrorObject.Name === 'string' ? ErrorObject.Name : undefined}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required
                    value={assetStatus}
                    label="Asset Status"
                    options={assetStatusTypes}
                    onChange={e => setAssetStatus(e.target.value)}
                    error={ErrorObject.AssetStatus}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={serialNumber == null || serialNumber == ""}
                    fullWidth
                    label="Tag Number"
                    value={tagNumber}
                    error={ErrorObject.TagNumber}
                    helperText={typeof ErrorObject.TagNumber === 'string' ? ErrorObject.TagNumber : undefined}
                    onChange={e => setTagNumber(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={tagNumber == null || tagNumber == ""}
                    fullWidth
                    label="Serial Number"
                    value={serialNumber}
                    error={ErrorObject.SerialNumber}
                    helperText={typeof ErrorObject.SerialNumber === 'string' ? ErrorObject.SerialNumber : undefined}
                    onChange={e => setSerialNumber(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    date={acquisitionDate}
                    onChange={date => setAquisitionDate(date)}
                    label={`Acquisition Date ${id ? " " : "*"}`}
                    error={ErrorObject.AcquisitionDate}
                    customHelperText={ErrorObject.AcquisitionDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowFuture={false}
                    allowPast={true}
                    date={disbursementDate}
                    onChange={date => setDisbursementDate(date)}
                    label="Disbursement Date"
                    disabled={assetStatus == 1}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast={true}
                    allowFuture={false}
                    date={installDate}
                    onChange={date => setInstallDate(date)}
                    label={`Install Date ${id ? " " : "*"}`}
                    error={ErrorObject.InstallDate}
                    customHelperText={ErrorObject.InstallDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={isCalifornia}
                    fullWidth
                    multiLine
                    label="Location On Site"
                    value={locationOnSite}
                    onChange={e => setLocationOnsite(e.target.value)}
                    error={ErrorObject.LocationOnSite}
                    customHelperText={ErrorObject.LocationOnSite}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required={isCalifornia}
                    value={manufacturer}
                    label="Manufacturer"
                    options={manufacturers}
                    onChange={e => setManufacturer(e.target.value)}
                    error={ErrorObject.Manufacturer}
                    customHelperText={ErrorObject.Manufacturer}
                />
            </FormFieldItem>
            <FormFieldItem>
                <DateInput
                    allowPast
                    allowFuture={false}
                    date={manufactureDate}
                    onChange={date => setManufactureDate(date)}
                    label="Manufacturer Date"
                    error={ErrorObject.ManufactureDate}
                    customHelperText={ErrorObject.ManufactureDate}
                    maxDate={maxDate}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    required={isCalifornia}
                    fullWidth
                    label="Model Number"
                    value={modelNumber}
                    onChange={e => setModelNumber(e.target.value)}
                    error={ErrorObject.ModelNumber}
                    customHelperText={ErrorObject.ModelNumber}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    required={isCalifornia}
                    value={modelYear}
                    label="Model Year"
                    options={years}
                    onChange={e => setModelYear(e.target.value)}
                    error={ErrorObject.ModelYear}
                    customHelperText={ErrorObject.ModelYear}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="Brand"
                    value={brand}
                    onChange={e => setBrand(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Input
                    fullWidth
                    label="PO Number"
                    value={poNumber}
                    onChange={e => setPONumber(e.target.value)}
                />
            </FormFieldItem>
            <FormFieldItem>
                <Select
                    value={lifeTime}
                    label="Expected Lifetime (years)"
                    options={lifeTimeOptions}
                    onChange={e => setLifeTime(e.target.value)}
                />
            </FormFieldItem>
        </CreateInventoryFormPanel>
    )

};

ControlsControl.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default ControlsControl;
